<template lang="pug">
div
  AuthHeader

  Intro(:isGiftClaimed="is_gift_claimed", @showPresent="showPresent")
  Features(@showVideo="showVideo")
  Classes
  Locations

  PromoFooter.promo-footer
  Registration(:showHeading="false")

  VideoPopup.decor-popup(:videoId="video_id", :videoType="video_type" @closeVideo="closeVideo")

  OldUserPopup(v-if="is_show_popup_for_old_user", @closePopup="closePopupForOldUser")
  GiftPopup(v-if="is_show_gift_popup", @closePopup="closeGiftPopup")
</template>

<script>
import AuthHeader from "@static_promo_pages/common/components/auth-header/vue/AuthHeader.vue";
import PromoFooter from "@static_promo_pages/common/components/footer/vue/Footer.vue";
import Registration from "@chronos/frontend-base/src/components/register/mygames/ProjectReg";
import OldUserPopupMixin from "@static_promo_pages/common/components/old-user-popup/mixins/OldUserPopupMixin";
import OldUserPopup from "@static_promo_pages/common/components/old-user-popup/vue/OldUserPopup.vue";
import VideoPopup from "@static_promo_pages/common/components/video-popup/vue/VideoPopup.vue";
import Intro from "./blocks/Intro";
import Features from "./blocks/Features";
import Classes from "./blocks/Classes";
import Locations from "./blocks/Locations";
import GiftPopup from "./blocks/GiftPopup";
import UserMixin from "@chronos/frontend-base/src/mixins/user/UserMixin";
export default {
  name: "PromoIndex",

  components: {
    AuthHeader,
    PromoFooter,
    Registration,
    Intro,
    Features,
    Classes,
    Locations,
    VideoPopup,
    OldUserPopup,
    GiftPopup,
  },

  mixins: [UserMixin, OldUserPopupMixin],

  data() {
    return {
      promo_name: "newstart",
      show_present_popup: false,
      video_id: null,
      video_type: null,
      is_show_gift_popup: false,
      is_gift_claimed: false,
    };
  },

  created() {
    document.addEventListener("init_vue_components", () => {
      this.initPromo();
    });
  },

  methods: {
    async initPromo() {
      await this.$store.dispatch("global/auth", { profile_fields: ["registration_url"] })
    },

    showVideo(video_type, video_id) {
      this.video_type = video_type;
      this.video_id = video_id;
    },

    closeVideo() {
      this.video_id = null;
    },

    showPresent() {
      if (this.isUserNotAuthed) {
        this.$authService.showSignup();
      } else if (!this.hasRegisteredHere) {
        this.showPopupForOldUser();
      } else {
        this.is_show_gift_popup = true;
      }
    },

    closeGiftPopup() {
      this.is_show_gift_popup = false;
    },
  },
};
</script>
